import antiflick from "@app/providers/scripts/antiflick";
import comscore from "@app/providers/scripts/comscore";
import domains from "@app/providers/scripts/domains";
import { taboolaScript } from "@app/providers/scripts/taboola";
import useLink from "@hooks/useLink";
import { fetchEnvelope, useLiveRamp } from "@hooks/useLiveRamp";
import useScript from "@hooks/useScript";
import useScriptFunction from "@hooks/useScriptFunction";

export default function HeadScriptProvider(): null {
  // Preconnect Scripts most frequently used
  useLink({
    id: "preconnect-googletagmanager",
    rel: "preconnect",
    href: domains.googletagmanager,
  });
  useLink({
    id: "preconnect-mysph",
    rel: "preconnect",
    href: domains.mysph,
  });
  useLink({
    id: "preconnect-doubleclick",
    rel: "preconnect",
    href: domains.doubleclick,
  });
  useLink({
    id: "preconnect-adtag",
    rel: "preconnect",
    href: domains.adtag,
  });
  useLink({
    id: "preconnect-taboola",
    rel: "preconnect",
    href: domains.taboola,
  });

  // Echobox script
  useScript({
    id: "ebx",
    src: "https://applets.ebxcdn.com/ebx.js",
    async: true,
  });

  // Taboola Script
  useScriptFunction({
    id: "taboola-script",
    value: taboolaScript,
  });

  // Anti flick script
  useScriptFunction({
    id: "anti-flick",
    value: antiflick,
  });

  // ComScore script
  useScriptFunction({
    id: "comscore",
    value: comscore,
  });

  // Live Implementation
  useLiveRamp({ fetchEnvelope });

  return null;
}
